import { Link } from "@tanstack/react-router";

import { useLocale } from "@/lib/i18n/context";
import logoFooterAsset from "@/assets/logo-footer.png.asset.json";



export function SiteFooter() {
  const { t } = useLocale();
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="mx-auto w-full max-w-[1400px] px-5 py-14 lg:px-8 lg:py-20">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <img
              src={logoFooterAsset.url}
              alt="Foreign Council On Economic Relations"
              width={290}
              height={83}
              loading="lazy"
              className="h-[83px] w-[290px]"
            />
          </div>


          <nav className="flex flex-col gap-4" aria-label="Footer">
            <Link to="/" className="fc-body hover:text-accent">
              {t.nav.home}
            </Link>
            <Link to="/new-diplomats" className="fc-body hover:text-accent">
              {t.nav.newDiplomats}
            </Link>
            <Link to="/meetings" className="fc-body hover:text-accent">
              {t.nav.allMeetings}
            </Link>
          </nav>

          <nav className="flex flex-col gap-4" aria-label="Footer secondary">
            <Link to="/about" className="fc-body hover:text-accent">
              {t.nav.about}
            </Link>
            <Link to="/contact" className="fc-body hover:text-accent">
              {t.nav.contact}
            </Link>
            <Link to="/imprint" className="fc-body hover:text-accent">
              {t.footer.imprint}
            </Link>
            <Link to="/privacy" className="fc-body hover:text-accent">
              {t.footer.privacy}
            </Link>
          </nav>
        </div>

        <p className="mt-12 border-t border-primary-foreground/20 pt-6 fc-eyebrow opacity-70">
          {t.footer.copyright}
        </p>
      </div>
    </footer>
  );
}
